import { render, staticRenderFns } from "./TrObject.vue?vue&type=template&id=a2083052&"
import script from "./TrObject.vue?vue&type=script&lang=js&"
export * from "./TrObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports